import React from 'react';
import "./footer-style.scss";
import {
    ReactComponent as LogoTurkishAirlines
} from 'assets/images/turkish-airlines-logo/logo-turkishairlines-white.svg';
import {useTranslation} from "react-i18next";
import {getFeedbackLink} from "../../../util/LanguageContentManager";
import {goLink} from "../../../util/OpenLink";
import {useSafeNavigate} from '../../../util/useSafeNavigate';

const FooterComponent = () => {

    const safeNavigate = useSafeNavigate();
    const {t, i18n} = useTranslation();

    const handleFeedbackBtn = () => {
        let link = getFeedbackLink(i18n);
        window.open(link, '_blank', 'noopener, noreferrer');
    }

    return (
        <div className="footer-bar">
            <div id="footer-root" className="footer-root">
                <div className="footer-page-head m-t-30"></div>
                <div className="footer-base">
                    <div className="footer">
                        <LogoTurkishAirlines/>
                    </div>
                    <div>
                        <p className="footer-contact">{t('system_status.your_comment_welcome')}</p>
                        <p className="footer-contact-link"
                           onClick={() => handleFeedbackBtn()}>{t('system_status.contact_us')}</p>
                    </div>
                    <div className="footer-link">
                        <span onClick={() => {
                            safeNavigate('/frequently-asked-questions')
                        }}>{t('frequently_asked_question.title')}</span>
                        <span onClick={() => {
                            goLink(t('links.privacy_policy'))
                        }}>{t('system_status.privacy_policy')}</span>
                        <span onClick={() => {
                            goLink(t('links.terms_conditions'))
                        }}>{t('system_status.terms_conditions')}</span>
                    </div>
                    <div className="footer-copyright">
                        <p>{t('copyright')}</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default FooterComponent;
